// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-name {
  font-family: AppFontLight;
  font-size: 12px;
  line-height: 16.55px;
  text-align: left;
}

h4 {
  display: flex;
  flex: 1;
}

.order-item {
  padding: 12px;
  margin-bottom: 17px;
  background: #ffffff;
  border-radius: var(--radius-default);
  box-shadow: 0px 0px 15px 0px rgba(125, 93, 40, 0.1019607843);
  border: 1px solid #939393;
}

.order-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  position: relative;
  padding-top: 100%;
  background: var(--ion-color-secondary-tint);
}
.order-image > ion-img {
  position: absolute;
  top: 8px;
  left: 8px;
  bottom: 8px;
  right: 8px;
}

.adds-price {
  margin-left: 5px;
  color: var(--ion-color-label);
}

ion-fab-button {
  --box-shadow: none;
}

.order-qty {
  margin: 10px 0;
}

.note {
  margin: 5px;
  font-size: small;
}

.qty__btn {
  width: 30px;
  height: 30px;
  margin: 0;
}
.qty__btn button {
  box-shadow: unset;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: auto;
}

.price {
  margin-left: 10px;
}

.qty {
  margin: 0 15px;
  font-size: 14px;
  color: #333333;
}

.article-price-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.price-col {
  padding: 0 0 0 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}

.article-price {
  font-family: AppFontMedium;
  font-size: 14px;
  font-weight: 500;
  line-height: 21.6px;
  letter-spacing: 0em;
  text-align: right;
  color: var(--color-black);
}

.edit-btn {
  margin-right: 5px;
}

ion-icon {
  height: 30px;
  width: 30px;
  cursor: pointer;
  color: var(--ion-color-primary);
}

app-quantity-selector {
  --quantity-selector-height: 30px;
  --quantity-selector-border-width: 0px;
  --quantity-selector-border-color: #785526;
  --quantity-selector-background: #785526;
  --quantity-selector-text-color: #fff;
}

.order-article-name {
  font-family: AppFontMedium;
  font-size: 16px;
  font-weight: 500;
  line-height: 16.6px;
  text-align: left;
  margin-bottom: 3px;
  color: #1e1e1c;
}

.order-article-description {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFont;
  font-size: 12px;
  line-height: 17.55px;
  color: #666666;
  margin-bottom: 7px;
}

.option-quantity {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
}

.pfand {
  font-size: 10px;
}

.name-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 0 0 5px;
}

.article-image {
  width: 51px;
  height: 46px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss"],"names":[],"mappings":"AAEA;EACC,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AADD;;AAIA;EACC,aAAA;EACA,OAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,4DAAA;EACA,yBAAA;AAFD;;AAKA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,2CAAA;AAFD;AAIC;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAFF;;AAMA;EACC,gBAAA;EACA,6BAAA;AAHD;;AAMA;EACC,kBAAA;AAHD;;AAMA;EACC,cAAA;AAHD;;AAMA;EACC,WAAA;EAEA,gBAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;EACA,SAAA;AAJD;AAMC;EACC,iBAAA;AAJF;AAOC;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AALF;;AASA;EACC,iBAAA;AAND;;AASA;EACC,cAAA;EACA,eAAA;EACA,cAAA;AAND;;AASA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;AAND;;AASA;EACC,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;AAPD;;AAUA;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAPD;;AAUA;EACC,iBAAA;AAPD;;AAUA;EACC,YAAA;EACA,WAAA;EACA,eAAA;EACA,+BAAA;AAPD;;AAUA;EACC,gCAAA;EACA,qCAAA;EACA,yCAAA;EACA,uCAAA;EACA,oCAAA;AAPD;;AAUA;EACC,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAPD;;AASA;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;AAND;;AAQA;EACC,oBAAA;EACA,kBAAA;EACA,cAAA;AALD;;AAOA;EACC,eAAA;AAJD;;AAOA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAJD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.option-name {\n\tfont-family: AppFontLight;\n\tfont-size: 12px;\n\tline-height: 16.55px;\n\ttext-align: left;\n}\n\nh4 {\n\tdisplay: flex;\n\tflex: 1;\n}\n\n.order-item {\n\tpadding: 12px;\n\tmargin-bottom: 17px;\n\tbackground: #ffffff;\n\t// border: 0.6px solid #9caeb9;\n\tborder-radius: var(--radius-default);\n\tbox-shadow: 0px 0px 15px 0px #7d5d281a;\n\tborder: 1px solid #939393;\n}\n\n.order-image {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 5px;\n\tposition: relative;\n\tpadding-top: 100%;\n\tbackground: var(--ion-color-secondary-tint);\n\n\t> ion-img {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tleft: 8px;\n\t\tbottom: 8px;\n\t\tright: 8px;\n\t}\n}\n\n.adds-price {\n\tmargin-left: 5px;\n\tcolor: var(--ion-color-label);\n}\n\nion-fab-button {\n\t--box-shadow: none;\n}\n\n.order-qty {\n\tmargin: 10px 0;\n}\n\n.note {\n\tmargin: 5px;\n\n\tfont-size: small;\n}\n\n.qty__btn {\n\twidth: 30px;\n\theight: 30px;\n\tmargin: 0;\n\n\tbutton {\n\t\tbox-shadow: unset;\n\t}\n\n\tspan {\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tleft: 0;\n\t\tright: 0;\n\t\tmargin: auto;\n\t}\n}\n\n.price {\n\tmargin-left: 10px;\n}\n\n.qty {\n\tmargin: 0 15px;\n\tfont-size: 14px;\n\tcolor: #333333;\n}\n\n.article-price-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n.price-col {\n\tpadding: 0 0 0 5px;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tjustify-content: space-between;\n}\n\n.article-price {\n\tfont-family: AppFontMedium;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tline-height: 21.6px;\n\tletter-spacing: 0em;\n\ttext-align: right;\n\tcolor: var(--color-black);\n}\n\n.edit-btn {\n\tmargin-right: 5px;\n}\n\nion-icon {\n\theight: 30px;\n\twidth: 30px;\n\tcursor: pointer;\n\tcolor: var(--ion-color-primary);\n}\n\napp-quantity-selector {\n\t--quantity-selector-height: 30px;\n\t--quantity-selector-border-width: 0px;\n\t--quantity-selector-border-color: #785526;\n\t--quantity-selector-background: #785526;\n\t--quantity-selector-text-color: #fff;\n}\n\n.order-article-name {\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tline-height: 16.6px;\n\ttext-align: left;\n\tmargin-bottom: 3px;\n\tcolor: #1e1e1c;\n}\n.order-article-description {\n\tmargin: 0;\n\tflex: 1;\n\tword-break: break-word;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 3;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 17.55px;\n\tcolor: #666666;\n\tmargin-bottom: 7px;\n}\n.option-quantity {\n\tfont-family: inherit;\n\tfont-size: inherit;\n\tcolor: inherit;\n}\n.pfand {\n\tfont-size: 10px;\n}\n\n.name-col {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: space-between;\n\tpadding: 0 0 0 5px;\n}\n\n.article-image {\n\twidth: 51px;\n\theight: 46px;\n\tobject-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
